import "./addbutton.css";

const AddButton = ({ label = "Add", onClick }) => {
  return (
    <button className="addButton" onClick={onClick}>
      + {label}
    </button>
  );
};

export default AddButton;